import type { ImportLogError } from "~/models/ImportLogError";

export const importTypes = [
	"company_vendor",
	"deal",
	"deal_estimation",
	"deal_billing_owner",
	"deal_billing_rentee"
] as const;
export const isImportType = (value: string): value is ImportType =>
	importTypes.some((importType) => importType === value);
export type ImportType = (typeof importTypes)[number];
export type ImportStatus =
	| "unprocessed"
	| "processing"
	| "normal_end"
	| "error_end";
export type ImportLog = {
	createdAt: string;
	deleteCount: number;
	errorCount: number;
	id: number;
	importCount: number;
	importLogErrors: ImportLogError[];
	importType: ImportType;
	rowCount: number | null;
	status: ImportStatus;
};
export type ImportLogWithCount = {
	count: number;
	logs: ImportLog[];
};
export type ImportLogsByType = {
	companyVendor: ImportLogWithCount;
	deal: ImportLogWithCount;
	dealBillingOwner: ImportLogWithCount;
	dealBillingRentee: ImportLogWithCount;
	dealEstimation: ImportLogWithCount;
};

const converter = {
	company_vendor: "companyVendor",
	deal: "deal",
	deal_billing_owner: "dealBillingOwner",
	deal_billing_rentee: "dealBillingRentee",
	deal_estimation: "dealEstimation"
} as const satisfies Record<ImportType, keyof ImportLogsByType>;
export const convertImportType = (
	importType: ImportType
): keyof ImportLogsByType => converter[importType];

export const importTypeLabels = {
	company_vendor: "施工会社",
	deal: "案件",
	deal_billing_owner: "請求情報（オーナー）",
	deal_billing_rentee: "請求情報（入居者）",
	deal_estimation: "施工会社見積"
} as const satisfies Record<ImportType, string>;

export const importStatusLabels = {
	error_end: "異常終了",
	normal_end: "正常終了",
	processing: "処理中",
	unprocessed: "未処理"
} as const satisfies Record<ImportStatus, string>;
